<template>
  <div class="limiter">
    <div class="container-login100" style="background-image: url('img/icons/bg-01.jpg');">
      <div class="wrap-login100 p-l-110 p-r-110 p-t-62 p-b-33">
        <!--  <form class="login100-form validate-form flex-sb flex-w"> -->
        <v-form class="login100-form validate-form flex-sb flex-w" ref="form" lazy-validation>
          <span class="login100-form-title p-b-53">Sign In With</span>

          <a href="#" class="btn-face m-b-20" @click="fb()">
            <v-icon>mdi-facebook</v-icon>Facebook
          </a>
          <!--   <v-btn class="btn-face m-b-20"> <v-icon>mdi-facebook</v-icon>
          Facebook</v-btn>-->

          <a href="#" class="btn-google m-b-20" @click="googleAuth()">
            <img src="img/icons/icon-google.png" alt="GOOGLE" />
            Google
          </a>

          <div class="p-t-31 p-b-9">
            <span class="txt1">Email</span>
          </div>
          <div class="wrap-input100 validate-input" data-validate="Username is required">
            <input class="input100" type="text" v-model="userEmail" />
            <span class="focus-input100"></span>
          </div>

          <div class="p-t-13 p-b-9">
            <span class="txt1">Password</span>
          </div>
          <div class="wrap-input100 validate-input" data-validate="Password is required">
            <input class="input100" type="password" v-model="userPassword" />
            <span class="focus-input100"></span>
          </div>

          <div class="container-login100-form-btn m-t-17">
            <!-- <button class="login100-form-btn" @click="signInWithMail()">Sign In</button> -->
            <v-btn class="login100-form-btn" @click="signInWithMailAuth()">Sign In</v-btn>
          </div>

          <div class="forgot w-full text-center p-t-55">
            <a
              href="#"
              class="txt2 bo1 m-l-5 ma-2"
              color="primary"
              dark
              @click="forgotModel = true"
            >Forgot Password?</a>
          </div>
          <!-- this.signUpCheckModel= true; -->

          <div class="forgot w-full text-center p-t-55">
            <a
              href="#"
              class="txt2 bo1 m-l-5 ma-2"
              color="primary"
              dark
              @click="test()"
            >Email verify?</a>
            <a href="#" class="txt2 bo1 m-l-5 ma-2" color="primary" dark @click="roles()">Roles?</a>
          </div>
          <div class="w-full text-center p-t-55">
            <span class="txt2">Not a member?</span>

            <a href="#" class="txt2 bo1" @click="signUpModel=true">Sign up now</a>
          </div>
          <v-dialog v-model="forgotModel" max-width="500px">
            <v-card>
              <v-card-title>Forgot Password</v-card-title>
              <v-card-text>
                <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>
                <center>
                  <v-btn color="primary" @click="forgotMail">Reset Your Password</v-btn>
                </center>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="forgotModel = false">Close</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="signUpCheckModel" max-width="500px">
            <v-card>
              <v-card-title>Email Confirmation</v-card-title>
              <p
                class="p-25 p-l-10"
              >If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.</p>
              <v-card-text>
                <center>
                  <v-btn block outlined color="success" @click="validate()">check</v-btn>
                </center>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog v-model="signUpModel" max-width="500px">
            <v-card>
              <v-card-title>Create Account</v-card-title>
              <v-card-text>
                <v-text-field
                  class="p"
                  append-icon="mdi-email-outline"
                  v-model="userEmail"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  class="p"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  v-model="signuppassword"
                  :rules="[rules.required, rules.min] "
                  label="Password"
                  :type="show1 ? 'text' : 'password'"
                  required
                ></v-text-field>
                <v-text-field
                  class="p"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  v-model="signuppasswordre"
                  :rules="[rules.required, rules.min,passwordConfirmationRule]"
                  label="Repeat Password"
                  hint="Password must be more than 4 characters"
                  :type="show1 ? 'text' : 'password'"
                  required
                ></v-text-field>
                <center>
                  <v-btn color="primary" @click="createAccount()">Create Account</v-btn>
                </center>
              </v-card-text>
              <v-card-actions>
                <v-btn color="primary" text @click="signUpModel = false">Close</v-btn>
              </v-card-actions>
              <v-card-actions>
                <v-btn color="primary" text @click="validate()">check</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-form>
      </div>
    </div>
    <v-snackbar
      v-model="snackbar"
      :timeout="timeout"
      :right="x === 'right'"
      :top="y === 'top'"
      :color="color"
    >
      {{ text }}
      <v-btn color="blue" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <!-- <v-snackbar :color="snackbar.color" v-model="snackbar.show">{{ snackbar.message }}</v-snackbar> -->
  </div>
</template>
<script>
import firebase from "firebase";
import router from "../router";
// import { constant } from "../../constantApp";
import { store } from "../../store";
import { theUsersRoles, theUsers } from "../../firebaseConfig";

export default {
  name: "Signin",

  data() {
    return {
      show: false,
      show1: false,
      forgotModel: false,
      signUpCheckModel: false,
      email: "",
      userEmail: "",
      userPassword: "",
      actionCodeSettings: "",
      signUpModel: false,
      signuppassword: "",
      signuppasswordre: "",
      signupemail: "",
      rules: {
        required: value => !!value || "Required.",
        min: v => v.length >= 5 || "Password must be more than 4 characters",
        emailMatch: () => "The email and password you entered don't match"
      },
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [
        v => !!v || "Password is required",
        v => (v && v.length >= 5) || "Password must be more than 4 characters"
      ],
      validateUser: {
        emailVerified: ""
      },
      /*       repeatpasswordRules: [
        v => !!v || "Repeat Password is required",
        v =>
          (v && v.length >= 5) ||
          "Repeat Password must be more than 4 characters",
       this.passwordConfirmationRule,
      ], */

      color: "",
      mode: "",
      snackbar: false,
      text: "Hello, I'm a snackbar",
      timeout: 6000,
      x: null,
      y: "top",
      myDBuser: null,
      googleResult: null

      /*     snackbar: {
        show: false,
        message: null,
        color: null
      } */
    };
  },
  computed: {
    passwordConfirmationRule() {
      return (
        this.signuppassword === this.signuppasswordre || "Password must match"
      );
    }
  },
  methods: {
    kamlesh() {
      console.log("kamlesh");
      return 10;
    },
    async roles() {
      //theUsersRoles.set

      theUsersRoles.child("p2RYzNzIPVNM5BOb8d3NE1un3Gn1").set({
        roles: "3"
      });
    },
    async test() {
      // var cars = ["basic", "gold", "plna"];
      // console.log(cars);
      // switch (cars[0]) {
      //   case 0:
      //     alert("basic");

      //     break;
      //   case 1:
      //     alert("gold");

      //     break;
      //   case 2:
      //     alert("plan");

      //     break;
      //   default:
      //     break;
      // }

      let response = await this.google();
      console.log(response);
      console.log("google");
      console.log(this.googleResult);

      if (this.googleResult != undefined) {
        console.log(this.googleResult);

        console.log(this.googleResult.user.uid);

        //  let mydbUsers= theUsersRoles
        //     .child(this.googleResult.user.uid)
        //     .on("value", snapshot => {
        //       console.log("roles tutututututu");
        //       this.myDBuser = snapshot.val();
        //       console.log("xxxxxxxxxxxxxxxxxxxxxxxxxx");
        //       console.log(this.myDBuser);
        //       console.log("xxxxxxxxxxxxxxxxxxxxxxxxxx");
        //       // console.log(DBUsers);
        //       return snapshot.val();
        //     });
        let mydbUsers = await this.rolesFunction(this.googleResult.user.uid);
        console.log("iiiiiiiiiiiiixxxxxxxxxxxxxxxx");
        console.log(this.myDBuser);
        console.log(mydbUsers);

        const txt = new Map();
        const roles = new Map();
        // roles.set("basic", true);
        if (this.myDBuser == null) {
          roles.set("permission", 1);
        } else {
          console.log("permission" + this.myDBuser.roles);
          roles.set("permission", this.myDBuser.roles);
        }
        txt.set("username", this.googleResult.user.displayName);
        txt.set("roles", Object.fromEntries(roles));
        console.log(Object.fromEntries(txt));
        console.log(JSON.stringify(txt));
        store.commit("change", Object.fromEntries(txt));
        // console.log(user);
        router.push("home");
      }
    },
    async rolesFunction(userId) {
      const snapshot = await theUsersRoles.child(userId).once("value");
      const value = snapshot.val();
      this.myDBuser = value;
      return value;
    },
    validate() {
      this.validateUser = firebase.auth().currentUser;

      if (this.validateUser != null) {
        if (this.validateUser.emailVerified == true) {
          this.successToast("Successfully Email Address verifed");
          this.signUpCheckModel = false;
        } else {
          this.dangerToast("Email verifed is pending");
          this.signUpCheckModel = false;
        }
      } else {
        this.dangerToast("Email verifed is pending");
        this.signUpCheckModel = false;
      }
      console.log(this.validateUser);
    },

    async createAccount() {
      let value, myerror;
      if (
        this.userEmail != "" &&
        this.signuppassword == this.signuppasswordre
      ) {
        await firebase
          .auth()
          .createUserWithEmailAndPassword(this.userEmail, this.signuppassword)
          .then(function() {
            var user = firebase.auth().currentUser;
            console.log("theCreate Account");
            console.log(user);
            console.log(user.uid);
            theUsers.child(user.uid).set({
              uid: user.uid,
              displayName: user.displayName,
              email: user.email,
              emailVerified: user.emailVerified
            });
            //console.log(user);
            if (localStorage) {
              localStorage.setItem("emailForSignIn", JSON.stringify(user));
            }
            value = true;
            myerror =
              "If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.";
            user
              .sendEmailVerification()
              .then(function() {
                value = true;
                myerror =
                  "If you do not receive a confirmation email, please check your spam folder. Also, please verify that you entered a valid email address in our sign-up form.";
                this.userEmail = "";
                this.userPassword = "";

                // this.signUpCheckModel = true;
              })
              .catch(function(error) {
                value = false;
                myerror = error.message;
              });
          })
          .catch(function(error) {
            // Handle Errors here.
            // var errorCode = error.code;
            //var errorMessage = error.message;
            value = false;
            myerror = error.message;
            console.log("error" + error);
            //  console.log("errorCode" + errorCode);
            //console.log("errorMessage" + errorMessage);
          });
      } else {
        value = false;
        myerror = "Please check values";
        // this.dangerToast("Please check values");
      }
      this.userEmail = "";
      this.userPassword = "";
      this.signuppassword = "";
      this.signuppasswordre = "";
      //this.signUpCheckModel = true;
      this.signUpModel = false;
      this.swal(value, myerror);
    },
    async signInWithMailAuth() {
      let user = await this.signInWithMail();
      console.log(user);
      console.log(this.googleResult);

      if (localStorage) {
        localStorage.setItem("emailForSignIn", JSON.stringify(this.googleResult));
      }

      await this.rolesFunction(this.googleResult.user.uid);
      const txt = new Map();
      const roles = new Map();
      if (this.myDBuser == null) {
        roles.set("permission", 1);
      } else {
        roles.set("permission", this.myDBuser.roles);
      }
      txt.set("username", this.googleResult.user.displayName);
      txt.set("roles", Object.fromEntries(roles));
      console.log(Object.fromEntries(txt));
      console.log(JSON.stringify(txt));
      store.commit("change", Object.fromEntries(txt));
      router.push("home");
    },
    async signInWithMail() {
      let value, errorss;
      // var user = firebase.auth().currentUser;
      //  console.log("before" + user.emailVerified);

      await firebase
        .auth()
        .signInWithEmailAndPassword(this.userEmail, this.userPassword)
        .then(result=> {
          var user = firebase.auth().currentUser;
          console.log(result);
          this.googleResult =result;
          console.log(this.googleResult);
          // console.log(user);
          //console.log("after" + user.emailVerified);
          if (user.emailVerified) {
            theUsers.child(user.uid).set({
              uid: user.uid,
              displayName: user.displayName,
              email: user.email,
              emailVerified: user.emailVerified
            });
            return user;
          } else {
            value = false;
            errorss = "Email verifed is pending";
          }
        })
        .catch(function(error) {
          // Handle Errors here.
          // var errorCode = error.code;
          //var errorMessage = error.message;
          value = false;

          console.log("error" + error);
          // console.log("errorCode" + errorCode);
          // console.log("errorMessage" + errorMessage);
          errorss = error.message;
        });

      this.swal(value, errorss);
    },
    async dangerToast(errorMessage) {
      this.text = errorMessage;
      this.snackbar = true;
      this.color = "error";
    },
    successToast(message) {
      this.text = message;
      this.snackbar = true;
      this.color = "success";
      this.$router.replace({ name: "home" });
    },
    async forgotMail() {
      // func.functionNames();
      //func.dangerToast("yoyoy");

      let value, myerror;

      await firebase
        .auth()
        .sendPasswordResetEmail(this.email)
        .then(function() {
          value = true;
        })
        .catch(function(error) {
          value = false;
          myerror = error.message;
          console.log("Something went wrong" + error);
        });
      this.forgotModel = false;
      this.swal(value, myerror);
    },
    swal(value, error) {
      //  console.log(constant.error.hello);
      if (value == true) {
        if (error == "" || error == undefined) {
          this.$swal.fire("success", "Email send successfully", "success");
        } else {
          this.$swal.fire("success", error, "success");
        }
      } else if (value == null) {
        //  console.log("null");
      } else {
        // console.log("value get" + error);
        if (error == "") {
          //   console.log("null value get" + error);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!"
          });
        } else {
          //  console.log("not null value get" + error);
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: error
          });
        }
      }
    },
    async googleAuth() {
      await this.google();
      if (this.googleResult != undefined) {
        await this.rolesFunction(this.googleResult.user.uid);
        const txt = new Map();
        const roles = new Map();
        if (this.myDBuser == null) {
          roles.set("permission", 1);
        } else {
          roles.set("permission", this.myDBuser.roles);
        }
        txt.set("username", this.googleResult.user.displayName);
        txt.set("roles", Object.fromEntries(roles));
        console.log(Object.fromEntries(txt));
        console.log(JSON.stringify(txt));
        store.commit("change", Object.fromEntries(txt));
        router.push("home");
      }
    },
    async google() {
      let value, myerror;
      var provider = new firebase.auth.GoogleAuthProvider();
      provider.addScope("profile");
      provider.addScope("email");
      // let dbRoles = await this.rolesThe(user);
      //console.log(dbRoles);
      await firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          this.googleResult = result;
          var user = result.user.uid;

          theUsers.child(user).set({
            uid: result.user.uid,
            displayName: result.user.displayName,
            email: result.user.email,
            emailVerified: result.user.emailVerified
          });
          return result;

          // theUsersRoles.child(user).on("value", snapshot => {
          //   console.log("roles tutututututu");
          //   dbRoles = snapshot.val();
          //   console.log(dbRoles);
          // });

          // const txt = new Map();
          // const roles = new Map();
          // // roles.set("basic", true);
          // roles.set("permission", 1);

          // txt.set("username", "kamleshkns");
          // txt.set("roles", Object.fromEntries(roles));
          // console.log("-----");
          // console.log(Object.fromEntries(txt));
          // console.log(JSON.stringify(txt));
          // store.commit("change", Object.fromEntries(txt));
          // console.log(user);
          // router.push("home");
        })
        .catch(function(error) {
          var errorCode = error.code;
          var errorMessage = error.message;
          value = false;
          myerror = error.message;
          console.log("error" + error);
          console.log("errorCode" + errorCode);
          console.log("errorMessage" + errorMessage);
        });

      this.swal(value, myerror);
    },
    async rolesThe() {
      console.log("rolesthe");
      let googleResult = await this.google();

      //this.dbuser =await this.google();
      console.log("get result");
      console.log(googleResult);
      return googleResult;
    },
    async fbAuth() {
      await this.fb();
      if (this.googleResult != undefined) {
        await this.rolesFunction(this.googleResult.user.uid);
        const txt = new Map();
        const roles = new Map();
        if (this.myDBuser == null) {
          roles.set("permission", 1);
        } else {
          roles.set("permission", this.myDBuser.roles);
        }
        txt.set("username", this.googleResult.user.displayName);
        txt.set("roles", Object.fromEntries(roles));
        console.log(Object.fromEntries(txt));
        console.log(JSON.stringify(txt));
        store.commit("change", Object.fromEntries(txt));
        router.push("home");
      }
    },
    async fb() {
      let value, myerror;
      var provider = new firebase.auth.FacebookAuthProvider();
      // provider.addScope("user_age_range");
      await firebase
        .auth()
        .signInWithPopup(provider)
        .then(result => {
          this.googleResult = result;
          var user = result.user.uid;

          theUsers.child(user).set({
            uid: result.user.uid,
            displayName: result.user.displayName,
            email: result.user.email,
            emailVerified: result.user.emailVerified
          });
          //return result;
          // This gives you a Facebook Access Token.
          // var token = result.credential.accessToken;
          // console.log(token);
          // // The signed-in user info.
          // var user = result.user;
          // console.log(user);
          router.push("home");
        })
        .catch(function(error) {
          // Handle Errors here.
          // var errorCode = error.code;
          // var errorMessage = error.message;
          value = false;
          myerror = error.message;
          console.log("error" + error);
          // console.log("errorCode" + errorCode);
          // console.log("errorMessage" + errorMessage);
        });
      this.swal(value, myerror);
    }
  }
};
</script>
<style scoped>
.p {
  padding: 7px;
}
.p-25 {
  padding: 25px;
}
.p-l-110 {
  padding-left: 110px;
}
.p-r-110 {
  padding-right: 110px;
}
.p-t-62 {
  padding-top: 62px;
}
.p-b-33 {
  padding-bottom: 33px;
}
.p-b-53 {
  padding-bottom: 53px;
}
.m-b-20 {
  margin-bottom: 20px;
}
.p-t-13 {
  padding-top: 13px;
}
.p-b-9 {
  padding-bottom: 9px;
}
.m-l-5 {
  margin-left: 5px;
}
.m-t-17 {
  margin-top: 17px;
}
.p-t-55 {
  padding-top: 55px;
}
/*//////////////////////////////////////////////////////////////////
[ login ]*/

.limiter {
  width: 100%;
  margin: 0 auto;
}

.container-login100 {
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  padding: 15px;

  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.wrap-login100 {
  width: 680px;
  background: #fff;
  border-radius: 10px;
  position: relative;
}
/*==================================================================
[ Form ]*/

.login100-form {
  width: 100%;
}

.login100-form-title {
  width: 100%;
  display: block;
  font-family: Montserrat-Medium;
  font-size: 39px;
  color: #555555;
  line-height: 1.2;
  text-align: center;
}

/*------------------------------------------------------------------
[ Button sign in with ]*/
.btn-face,
.btn-google {
  font-family: Montserrat-SemiBold;
  font-size: 18px;
  line-height: 1.2;

  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 15px;
  width: calc((100% - 20px) / 2);
  height: 70px;
  border-radius: 10px;
  box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.2);
  -moz-box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.2);
  -webkit-box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.2);
  -o-box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.2);
  -ms-box-shadow: 0 1px 5px 0px rgba(0, 0, 0, 0.2);
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
  position: relative;
  z-index: 1;
}

.btn-google::before,
.btn-face::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  top: 0;
  left: 0;
  background: #a64bf4;
  background: -webkit-linear-gradient(45deg, #00dbde, #fc00ff);
  background: -o-linear-gradient(45deg, #00dbde, #fc00ff);
  background: -moz-linear-gradient(45deg, #00dbde, #fc00ff);
  background: linear-gradient(45deg, #00dbde, #fc00ff);
  opacity: 0;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.btn-face {
  color: #fff;
  background-color: #3b5998;
}

.btn-face i {
  font-size: 30px;
  margin-right: 17px;
  padding-bottom: 3px;
}

.btn-google {
  color: #555555;
  background-color: #fff;
}

.btn-google img {
  width: 30px;
  margin-right: 15px;
  padding-bottom: 3px;
}

.btn-face:hover:before,
.btn-google:hover:before {
  opacity: 1;
}

.btn-face:hover,
.btn-google:hover {
  color: #fff;
}

/*------------------------------------------------------------------
[ Input ]*/

.wrap-input100 {
  width: 100%;
  position: relative;
  background-color: #f7f7f7;
  border: 1px solid #e6e6e6;
  border-radius: 10px;
}

/*---------------------------------------------*/
.input100 {
  font-family: Poppins-Regular;
  color: #333333;
  line-height: 1.2;
  font-size: 18px;

  display: block;
  width: 100%;
  background: transparent;
  height: 60px;
  padding: 0 20px;
}
/*------------------------------------------------------------------
[ Focus Input ]*/

.focus-input100 {
  position: absolute;
  display: block;
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  top: -1px;
  left: -1px;
  pointer-events: none;
  border: 1px solid #fc00ff;
  border-radius: 10px;

  visibility: hidden;
  opacity: 0;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;

  -webkit-transform: scaleX(1.1) scaleY(1.3);
  -moz-transform: scaleX(1.1) scaleY(1.3);
  -ms-transform: scaleX(1.1) scaleY(1.3);
  -o-transform: scaleX(1.1) scaleY(1.3);
  transform: scaleX(1.1) scaleY(1.3);
}

.input100:focus + .focus-input100 {
  visibility: visible;
  opacity: 1;

  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}

.eff-focus-selection {
  visibility: visible;
  opacity: 1;

  -webkit-transform: scale(1);
  -moz-transform: scale(1);
  -ms-transform: scale(1);
  -o-transform: scale(1);
  transform: scale(1);
}

/*------------------------------------------------------------------
[ Button ]*/
.container-login100-form-btn {
  width: 100%;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  flex-wrap: wrap;
}

.login100-form-btn {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 20px;
  width: 100%;
  height: 60px;
  background-color: #333333;
  border-radius: 10px;

  font-family: Poppins-Medium;
  font-size: 16px;
  line-height: 1.2;

  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
  position: relative;
  z-index: 1;
}

.login100-form-btn::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  top: 0;
  left: 0;
  background: #a64bf4;
  background: -webkit-linear-gradient(45deg, #00dbde, #fc00ff);
  background: -o-linear-gradient(45deg, #00dbde, #fc00ff);
  background: -moz-linear-gradient(45deg, #00dbde, #fc00ff);
  background: linear-gradient(45deg, #00dbde, #fc00ff);
  opacity: 0;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
  transition: all 0.4s;
}

.login100-form-btn:hover:before {
  opacity: 1;
}

/*------------------------------------------------------------------
[ Alert validate ]*/

.validate-input {
  position: relative;
}

.alert-validate::before {
  content: attr(data-validate);
  position: absolute;
  max-width: 70%;
  background-color: #fff;
  border: 1px solid #c80000;
  border-radius: 2px;
  padding: 4px 25px 5px 10px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 12px;
  pointer-events: none;

  font-family: Poppins-Regular;
  color: #c80000;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;

  visibility: hidden;
  opacity: 0;

  -webkit-transition: opacity 0.4s;
  -o-transition: opacity 0.4s;
  -moz-transition: opacity 0.4s;
  transition: opacity 0.4s;
}

.alert-validate::after {
  content: "\f12a";
  font-family: FontAwesome;
  display: block;
  position: absolute;
  color: #c80000;
  font-size: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 18px;
}

.alert-validate:hover:before {
  visibility: visible;
  opacity: 1;
}

@media (max-width: 992px) {
  .alert-validate::before {
    visibility: visible;
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .wrap-login100 {
    padding-left: 60px;
    padding-right: 60px;
  }

  @media (max-width: 576px) {
    .wrap-login100 {
      padding-left: 15px;
      padding-right: 15px;
    }

    .btn-face,
    .btn-google {
      width: 100%;
    }
  }
}
/* @font-face {
  font-family: Poppins-Regular;
  src: url('../fonts/poppins/Poppins-Regular.ttf'); 
}

@font-face {
  font-family: Poppins-Medium;
  src: url('../fonts/poppins/Poppins-Medium.ttf'); 
}

@font-face {
  font-family: Montserrat-Medium;
  src: url('../fonts/montserrat/Montserrat-Medium.ttf'); 
}

@font-face {
  font-family: Montserrat-SemiBold;
  src: url('../fonts/montserrat/Montserrat-SemiBold.ttf'); 
} */

/*//////////////////////////////////////////////////////////////////
[ RESTYLE TAG ]*/

* {
  margin: 0px;
  padding: 0px;
  box-sizing: border-box;
}

body,
html {
  height: 100%;
  font-family: Poppins-Regular, sans-serif;
}

/*---------------------------------------------*/
a {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
  transition: all 0.4s;
  -webkit-transition: all 0.4s;
  -o-transition: all 0.4s;
  -moz-transition: all 0.4s;
}

a:focus {
  outline: none !important;
}

a:hover {
  text-decoration: none;
  color: #fc00ff;
  border-color: #fc00ff;
}

/*---------------------------------------------*/
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0px;
}

p {
  font-family: Poppins-Regular;
  font-size: 14px;
  line-height: 1.7;
  color: #666666;
  margin: 0px;
}

ul,
li {
  margin: 0px;
  list-style-type: none;
}

/*---------------------------------------------*/
input {
  outline: none;
  border: none;
}

textarea {
  outline: none;
  border: none;
}

textarea:focus,
input:focus {
  border-color: transparent !important;
}

input:focus::-webkit-input-placeholder {
  color: transparent;
}
input:focus:-moz-placeholder {
  color: transparent;
}
input:focus::-moz-placeholder {
  color: transparent;
}
input:focus:-ms-input-placeholder {
  color: transparent;
}

textarea:focus::-webkit-input-placeholder {
  color: transparent;
}
textarea:focus:-moz-placeholder {
  color: transparent;
}
textarea:focus::-moz-placeholder {
  color: transparent;
}
textarea:focus:-ms-input-placeholder {
  color: transparent;
}

input::-webkit-input-placeholder {
  color: #555555;
}
input:-moz-placeholder {
  color: #555555;
}
input::-moz-placeholder {
  color: #555555;
}
input:-ms-input-placeholder {
  color: #555555;
}

textarea::-webkit-input-placeholder {
  color: #555555;
}
textarea:-moz-placeholder {
  color: #555555;
}
textarea::-moz-placeholder {
  color: #555555;
}
textarea:-ms-input-placeholder {
  color: #555555;
}

label {
  display: block;
  margin: 0;
}

/*---------------------------------------------*/
button {
  outline: none !important;
  border: none;
  background: transparent;
}

button:hover {
  cursor: pointer;
}

iframe {
  border: none !important;
}

/*//////////////////////////////////////////////////////////////////
[ Utility ]*/
.txt1 {
  font-family: Montserrat-SemiBold;
  font-size: 16px;
  color: #555555;
  line-height: 1.5;
}

.txt2 {
  font-family: Poppins-Regular;
  font-size: 14px;
  color: #999999;
  line-height: 1.5;
}

.bo1 {
  border-bottom: 1px solid #999999;
}
.flex-sb {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  justify-content: space-between;
}
.flex-w {
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-flex-wrap: wrap;
  -moz-flex-wrap: wrap;
  -ms-flex-wrap: wrap;
  -o-flex-wrap: wrap;
  flex-wrap: wrap;
}
/* @font-face {
  font-family: Poppins-Regular;
 -
  src: url("assests/Music/Poppins-Regular.ttf")  format('truetype'); 
} */

/* @font-face {
  font-family: Poppins-Medium;
  src: url('./assets/fonts/poppins/Poppins-Medium.ttf'); 
}

@font-face {
  font-family: Montserrat-Medium;
  src: url('./assets/fonts/montserrat/Montserrat-Medium.ttf'); 
}

@font-face {
  font-family: Montserrat-SemiBold;
  src: url('./assets/fonts/montserrat/Montserrat-SemiBold.ttf'); 
}
 */
</style>